import FormErrorType from '@/types/form/FormErrorType';

export type FormError = {
    property: string;
    message: string;
    type: FormErrorType;
};

export const getSentryAnonymousUserGuid = () => {
    try {
        const storedUserId = localStorage.getItem("sentry-user-id");

        if (storedUserId) {
            return storedUserId;
        }

        const userId = crypto.randomUUID();

        localStorage.setItem("sentry-user-id", userId);

        return userId;
    }
    catch {
        return crypto.randomUUID();
    }
}

export const createSentryAnonymousUser = () => {
    const userGuid = getSentryAnonymousUserGuid();

    return {
        id: `Anonymous - ${userGuid}`,
        username: `Anonymous - ${userGuid}`,
        fullName: 'Anonymous User'
    }
}